import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

const BANNER_MIN_HEIGHT = 200;

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  content: {
    flex: 1,
    minHeight: BANNER_MIN_HEIGHT,
    backgroundColor: white,
    marginHorizontal: indent,
    marginBottom: indent,
    borderColor: '#ccc',
    borderWidth: 1,
    padding: indent,
    borderRadius: 10,
  },
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    width: '90%',
    marginLeft: indent * 1,
    borderRadius: indent * 0.5,
    flexDirection: 'row',
  },
  subTitle: {
    fontSize: 18,
    marginBottom: 8,
  },
  title: {
    fontSize: 14,
    marginBottom: 8,
    fontWeight: '600',
    color: '#556B2F',
  },

  subtitle: {
    fontSize: 14,
    marginBottom: 16,
  },
  streakBadge: {
    backgroundColor: '#E0F2FE',
    padding: indent * 0.6,
    borderRadius: 10,
    alignSelf: 'center',
    marginBottom: 16,
    borderWidth: 0.5,
    borderColor: '#E0F2FE',
  },
  streakText: {
    color: 'blue',
  },
  button: {
    backgroundColor: '#556B2F',
    paddingVertical: 12,
    borderRadius: 10,
    alignItems: 'center',
  },
  buttonText: {
    color: '#FFF',
    fontSize: 16,
  },
});
